import classnames from "classnames";
import Image from "next/legacy/image";
import Button from "./UI/Button";
import { Modal } from "./Modal";
import loadingBlack from "../public/icon/loading-black.png";
import { debounce } from "@mui/material/utils";

interface ComfirmModalProps {
  className?;
  okText?;
  cancelText?;
  title;
  desc?;
  onOk?;
  onCancel?(from: "icon" | "button"): void;
  confirmLoading?;
  noOkBtn?;
}

const Icon = () => {
  return (
    <svg
      width="50"
      height="34"
      viewBox="0 0 50 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25 0C9.70178 0 12.5 2.76769 12.5 6.18182V27.8182C12.5 31.2323 9.70178 34 6.25 34C2.79822 34 0 31.2323 0 27.8182L0 6.18182C0 2.76769 2.79822 0 6.25 0ZM43.75 0C47.2018 0 50 2.76769 50 6.18182V27.8182C50 31.2323 47.2018 34 43.75 34C40.2982 34 37.5 31.2323 37.5 27.8182V6.18182C37.5 2.76769 40.2982 0 43.75 0Z"
        fill="url(#paint0_linear_2327_5142)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2327_5142"
          x1="25"
          y1="0"
          x2="25"
          y2="34"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.130208" stopColor="#2F3238" />
          <stop offset="1" stopColor="#2F3238" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const noop = () => {};

export const ConfirmModal = ({
  className = "",
  okText = "Yes",
  cancelText = "No",
  title,
  desc,
  onOk = noop,
  onCancel = noop,
  confirmLoading = false,
  noOkBtn = false,
}: ComfirmModalProps) => {
  return (
    <Modal
      className={classnames(
        "w-[416px] rounded-[48px] overflow-hidden p-[40px] pt-[48px] text-center",
        className
      )}
      onClose={() => {
        onCancel("icon");
      }}
    >
      <div className="mb-[32px]">
        <Icon />
      </div>
      <div className="text-[24px] leading-[32px] font-['DIN_Alternate']">
        {title}
      </div>
      {
        desc && (
          <div className="mt-[16px] text-[14px] leading-[20px] font-medium">{ desc }</div>
        )
      }
      <div className="mt-[40px] flex justify-between h-[40px]">
        {!noOkBtn && (
          <button
            onClick={confirmLoading ? null : debounce(onOk || noop, 300)}
            className={classnames(
              "btn-unstyled h-full w-[160px] text-black border border-black border-solid rounded-full transition",
              {
                "hover:text-[#ff2800] hover:border-[#ff2800]": !confirmLoading,
                "cursor-default": confirmLoading,
              }
            )}
          >
            {confirmLoading && (
              <span className="mr-[8px]">
                <Image
                  src={loadingBlack}
                  alt=""
                  className="animate-[loading_1s_linear_infinite]"
                  width={12}
                  height={12}
                />
              </span>
            )}
            <span>{okText}</span>
          </button>
        )}
        <Button
          variant="contained"
          color="secondary"
          component="span"
          className={classnames(
            "h-full rounded-full hover:opacity-80",
            noOkBtn ? "w-full" : "w-[160px]"
          )}
          onClick={() => {
            onCancel("button");
          }}
        >
          <span className="text-[16px] text-[#FFF]">{cancelText}</span>
        </Button>
      </div>
    </Modal>
  );
};
